export const OnboardingAdminUrls = {
    GetOnboardingConfig: "OnboardingAdmin/GetOnboardingConfig",
    GetAvailableLandingPages: "OnboardingAdmin/GetAvailableLandingPages",
    GetODataModels: "OnboardingAdmin/GetODataModels",
    DeleteOnboardingConfig: "OnboardingAdmin/DeleteOnboardingConfig",
    DeleteOnboardingPlugin: "OnboardingAdmin/DeleteOnboardingPlugin",
    SaveOnboardingConfig: "OnboardingAdmin/SaveOnboardingConfig",
    RunOnboardingRulesTest: "OnboardingAdmin/RunOnboardingRulesTest",
    SaveOffering: "OnboardingAdmin/SaveOffering",
    CloneOnboardingConfig: "OnboardingAdmin/CloneOnboardingConfig",
    CloneOnboardingPlugin: "OnboardingAdmin/CloneOnboardingPlugin",
    UploadFiles: "OnboardingAdmin/UploadFiles",
    GetOnboardingRequest: "OnboardingAdmin/GetOnboardingRequest",
    CreateDynamicOnboardingPlugin: "OnboardingAdmin/CreateDynamicOnboardingPlugin",
    GetSharedAccessSignatureToken: "OnboardingAdmin/GetSharedAccessSignatureToken"
}

export const OnboardingClientUrls = {
    ShortenUrl: "OnboardingClient/ShortenUrl",
    SaveUrlsHistory: "OnboardingClient/SaveUrlsHistory",
    GetOnboardingClientConfiguration: "OnboardingClient/GetOnboardingClientConfiguration",
    GetAdvancedMetaConfiguration: "OnboardingClient/GetAdvancedMetaConfiguration",
    GetRequiredDocumentTypes: "OnboardingClient/GetRequiredDocumentTypes",
    UpdateAdvancedMeta: "OnboardingClient/UpdateAdvancedMeta",
    UploadDocuments: "OnboardingClient/UploadDocuments",
    ValidateUploadDocuments: "OnboardingClient/ValidateUploadDocuments",
    RejectOnboardingRequest: "OnboardingClient/RejectOnboardingRequest",
    CompleteOnboardingRequest: "OnboardingClient/CompleteOnboardingRequest",
    SaveVerificationMeta: "OnboardingClient/SaveVerificationMeta",
    ValidateOnboardingRequest: "OnboardingClient/ValidateOnboardingRequest",
    ValidateOnboardingOffering: "OnboardingClient/ValidateOnboardingOffering",
    ValidateOnboardingOfferings: "OnboardingClient/ValidateOnboardingOfferings",
    CreateOrUpdateOnboardingRequest: "OnboardingClient/CreateOrUpdateOnboardingRequest",
    UpdateOfferingsSelection: "OnboardingClient/UpdateOfferingsSelection",
    GetOfferingsForOnboardingRequest: "OnboardingClient/GetOfferingsForOnboardingRequest",
    GetVerifications: "OnboardingClient/GetVerifications",
    UploadFiles: "OnboardingClient/UploadFiles",
    GetOnboardingRequest: "OnboardingClient/GetOnboardingRequest",
    SaveClientNotes: "OnboardingClient/SaveClientNotes",
    SaveGdprConsent: "OnboardingClient/SaveGdprConsent",
    GetSharedAccessSignatureToken: "OnboardingClient/GetSharedAccessSignatureToken"
}
